import { render, staticRenderFns } from "./submitding.vue?vue&type=template&id=1cc50e12"
import script from "./submitding.vue?vue&type=script&lang=js"
export * from "./submitding.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports